import React from 'react'

const TermsOfServicePage = () => {
  return (
    <div className={` w-full relative py-[1rem] xl:py-6`}>
      <div className="w-full flex justify-center">
        <div
          style={{ maxWidth: '1056px', lineHeight: '1.875rem' }}
          className={`custom-page px-[5%] xl:px-0`}
        >
          <div style={{ color: 'white' }} className="custom-page-terms">
            <div>
              <h2>
                <strong>LUMICKO</strong>
              </h2>
              <h2>
                <strong>TERMS OF SERVICE</strong>
              </h2>
              <br />
              <p>
                <strong>1. </strong>
                <strong>IMPORTANT TO TAKE NOTE</strong>
              </p>
              <ol type="a">
                <li>
                  Please read these terms of service (“Terms of Service”) carefully as they apply to
                  your use of the LUMICKO Service, which can be accessed through the LUMICKO website
                  at www.lumicko.com; and the LUMICKO application (together the “Sites” and each a
                  “Site”). By using and/or accessing any Site you agree to be bound by these Terms
                  of Service (as may be updated from time to time).
                </li>
                <li>
                  We operate the Sites but we exercise little to no editorial control over some of
                  the Content on the Sites, and in some cases other approved third parties provide
                  the Content on the Sites or operate parts of the Sites or other Internet sites you
                  may view or access through the Sites (“Third Party Providers”).
                </li>
                <li>
                  We update these Terms of Service from time to time. It is your responsibility to
                  check for updates to these Terms of Service as they take effect upon posting on
                  any Site, because, unless otherwise required by Applicable Law, your continued use
                  of the Sites following such variation or amendments of these Terms of Service,
                  whether or not reviewed by you, shall constitute your acceptance to be bound by
                  such variations or amendments.
                </li>
              </ol>
              <br />
              <p>
                <strong>2. </strong>

                <strong>REGISTRATION AS A USER</strong>
              </p>
              <ol type="a">
                <li>
                  The LUMICKO Service
                  <ol type="i">
                    <li>
                      The accessibility of the LUMICKO Service through different devices depends,
                      amongst other things, on the operating systems and/or browsers installed on
                      your device(s).
                    </li>
                    <li>
                      All parts of the LUMICKO Service are provided to registered users free of
                      charge.
                    </li>
                    <li>
                      The LUMICKO Service can be accessed in any territory where we offer such
                      services and accessible in countries determined by us.
                    </li>
                    <li>
                      Using the LUMICKO Service through an internet or mobile network may result in
                      broadband or mobile data charges. Please contact your service provider for
                      more information.
                    </li>
                    <li>
                      In order to access the Sites (“Post-Registration Features”), you :
                      <ul className="list-disc">
                        <li>
                          are required to provide us with accurate, complete and updated
                          registration information;
                        </li>
                        <li>are required to safeguard your username and password; and</li>
                        <li>
                          authorize us to assume that any person using any Site with your username
                          and password is either you or authorized by you to do so.
                        </li>
                        <li>
                          acknowledge that your use of some Post-Registration Features may be
                          governed by additional terms and conditions. Where this is the case, you
                          will be notified accordingly, and those additional terms and conditions:
                        </li>

                        <li>
                          will apply to your use of such Post-Registration Features in addition to
                          these Terms of Service; and
                        </li>
                        <li>
                          will prevail over these Terms of Service to the extent of any
                          inconsistency.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ol>

              <br />
              <p>
                <strong>3. </strong>
                <strong>THE </strong>
                <strong>SERVICE</strong>
              </p>
              <ol type="a">
                <li>
                  You acknowledge that we may at any time, in our sole discretion and with or
                  without notice:
                  <ol type="i">
                    <li>
                      deactivate and/or suspend the LUMIKO Service (or part thereof) at any time to
                      carry out system maintenance, upgrading, testing and/or repairs;
                    </li>
                    <li>vary the Sites (or any part thereof); and</li>
                    <li>
                      discontinue any Site, cease providing the LUMICKO Service (or any part
                      thereof) and/or any Content to you.
                    </li>
                  </ol>
                </li>
              </ol>

              <br />
              <p>
                <strong>4</strong>
                <strong>. </strong>
                <strong>SITE CONTENT</strong>
              </p>
              <ol type="a">
                <li>
                  You have to be aged 18 or above to access or use the LUMICKO Service and/or
                  Content.
                </li>
                <li>
                  You are only authorised to use the LUMICKO Service and view the Content for your
                  own personal and non-commercial use in accordance with these Terms of Service.
                </li>
                <li>
                  You agree that the LUMICKO Service and Content are only for your private viewing
                  and access and shall not yourself, or permit any other person to, show, play, use,
                  access or view the LUMICKO Service and/or Content for any public or commercial
                  purposes unless with our prior written consent.
                </li>
                <li>
                  You will in your use and/or access of the LUMICKO Service abide by all Applicable
                  Law and any operating and/or usage rules, as amended from time to time.
                </li>
                <li>
                  Without limiting clauses 4(b) and 4(c) above, you shall not charge for use or
                  access to the LUMICKO Service and/or any Content; or for access to any premises
                  where the LUMICKO Service and/or Content are viewed.
                </li>
                <li>
                  You acknowledge that Content on the Sites is subject to copyright and possibly
                  other intellectual property rights. Unless expressly authorized by Applicable Law
                  or permitted by us, you must not by yourself or permit any other person to:
                  <ol type="i">
                    <li>
                      sell, rent, reproduce, duplicate, distribute, modify, display, publish,
                      publicly perform, prepare derivative works based on, repost or otherwise use
                      any of the Content in any way for any public or commercial purpose without our
                      prior written consent;
                    </li>
                    <li>
                      use any Content on any other website or in a networked computer environment
                      for any purpose;
                    </li>
                    <li>
                      reverse engineer any Content consisting of downloadable software; and/or
                    </li>
                    <li>
                      otherwise infringe the intellectual property rights of any person or entity in
                      using and/or accessing any Site or any Content.
                    </li>
                  </ol>
                </li>
                <li>
                  Nothing you do on or in relation to the Sites will transfer any intellectual
                  property rights to you or license you to exercise any intellectual property rights
                  unless this is expressly stated.
                </li>
                <li>
                  You acknowledge that:
                  <ol type="i">
                    <li>
                      we can vary, replace or withdraw any Content, channels and programs (whether
                      advertised or not) on the LUMICKO Service, including changing or reducing the
                      number of hours of broadcast of any channel or any program on the LUMICKO
                      Service; and
                    </li>
                    <li>
                      we can expand, reduce, withdraw and/or modify any part of the LUMICKO Service
                      and/or any Content, remove, disable and/or suspend transmission or streaming
                      of the LUMICKO Service and/or Content which we consider in our sole opinion,
                      breaches any Applicable Law or to be otherwise unacceptable.
                    </li>
                  </ol>
                </li>
              </ol>

              <br />
              <p>
                <strong>5. </strong>
                <strong>HOW YOU USE THE SITE</strong>
              </p>
              <ol type="a">
                <li>
                  You must not:
                  <ol type="i">
                    <li>
                      disrupt or interfere with the Sites, LUMICKO Service, servers, networks,
                      software, hardware or equipment connected to or via the Sites and/or LUMICKO
                      Service;
                    </li>
                    <li>
                      violate any Applicable Law relating to your use of any Site and/or the LUMICKO
                      Service;
                    </li>
                    <li>
                      collect or store personal data about other users of the Sites and/or the
                      LUMICKO Service;
                    </li>
                    <li>
                      {`restrict or inhibit any other persons from using any Site and/or LUMICKO Service,
                  including, without limitation, by means of "hacking" or defacing any portion of
                  any Site and/or the LUMICKO Service;`}
                    </li>
                    <li>
                      access or use the Sites, LUMICKO Service, Content or Software for any unlawful
                      purpose or any purpose not expressly authorised by these Terms of Service;
                    </li>
                    <li>
                      modify, adapt, sub-license, reproduce, distribute, copy, exploit, translate,
                      sell, reverse engineer, decompile or disassemble any portion of the Sites,
                      LUMICKO Service, Software and/or Content;
                    </li>
                    <li>
                      remove any copyright, trademark, or other proprietary rights notices contained
                      in the Sites, LUMICKO Service and/or Content;
                    </li>
                    <li>
                      copy and/or frame any part of the Sites, LUMICKO Service and/or Content
                      without our prior written authorisation;
                    </li>
                    <li>
                      {`use any robot, spider, site search or retrieval application, or other manual or
                  automatic device or process to retrieve, index, "data mine", or in any way
                  reproduce, disrupt or circumvent the navigational structure or presentation of the
                  Sites, LUMICKO Service and/or the Content;`}
                    </li>
                    <li>
                      hack, break into, or attempt to hack or break into, in any manner the Sites,
                      LUMICKO Service, Software and/or any data areas on our server(s) or that of
                      any third parties;
                    </li>
                    <li>
                      download, copy, store, rip, distribute, share or re-direct any Content from
                      the Sites and/or LUMICKO Service in any way or through any media;
                    </li>
                    <li>
                      incorporate any software or other materials that contain any virus, malicious
                      code, worm, time bomb, Trojan horse, or other harmful or disruptive component;
                    </li>
                    <li>
                      forge headers or otherwise manipulate identifiers in order to disguise the
                      origin of any content transmitted through the Sites and/or LUMICKO Service; or
                    </li>
                    <li>
                      issue, create or sponsor any financial instruments or investment products
                      where the price, return and/or performance of such instrument or product is
                      based on or related to any financial index or information in the Content.
                    </li>
                  </ol>
                </li>
                <li>
                  Our authorisation for you to access the Sites; and receive the LUMICKO Service and
                  the Content is conditional upon your strict compliance with each of these Terms of
                  Service.
                </li>
                <li>
                  We may at any time, and subject to Applicable Law employ and/or install software
                  in any device(s) used by you, where it is necessary for purposes of detecting any
                  unlawful downloading, copying, storing, ripping, distribution, sharing or
                  re-direction of any Content from the Sites and/or LUMICKO Service in any way or
                  through any media.
                </li>
                <li>
                  The provision of the LUMICKO Service and availability of certain features and
                  services is contingent upon the service capacity allocated by us (including but
                  not limited to streaming capacity) for the LUMICKO Service, the reliability, speed
                  and stability of your Internet connection and bandwidth, as well as the
                  specifications and performance of your devices or the respective software used,
                  all of which are out of our control. We will not be liable to you or any other
                  third parties (including users of the LUMICKO Service (whether authorised or not))
                  for any failure or delay in accessing the Sites, LUMICKO Service or any parts,
                  features and/or content thereof (whether due to the lack of streaming capacity or
                  otherwise) and/or the consequences or effects on your Internet connection, its
                  speed and/or bandwidth that may be caused by the Sites and/or LUMICKO Service.
                </li>
                <li>
                  You may access the public posts of the social media profile (such as Facebook
                  pages) of others through specified features within the Sites and/or LUMICKO
                  Service. You acknowledge that we do not own, are not responsible for nor have any
                  responsibilities to any of the posts and/or comments made by other third parties
                  to the Facebook pages linked through the Sites and/or LUMICKO Service, and that by
                  linking to these Facebook pages does not mean we endorse in any way the content of
                  such posts in the relevant Facebook pages. The Facebook, the “Like” button, the
                  “Share” button, the “f” logo are all trade marks, and/or trade names and
                  properties of Facebook.
                </li>
                <li>
                  In relation to Software:
                  <ol type="i">
                    <li>
                      You may from time to time be requested by us, to download Software and we
                      hereby grant to you a non-exclusive, revocable and non-transferable license
                      for you to store, run and use the Software on your devices in accordance with
                      these Terms of Use and any software license which accompanies the Software but
                      not further or otherwise;
                    </li>
                    <li>
                      You agree to download and install the Software in such personal devices to be
                      used by you for accessing and/or installing the Sites and LUMICKO Service; and
                    </li>
                    <li>
                      You acknowledge that we may refuse to provide the LUMICKO Service to you in
                      the event you fail to successfully download and install the Software.
                    </li>
                  </ol>
                </li>
              </ol>

              <br />

              <p>
                <strong>6. THIRD PARTY PROVIDERS</strong>
              </p>
              <ol type="a">
                <li>
                  You acknowledge that parts of the Sites and parts of the Content are provided or
                  maintained by Third Party Providers and not by us.
                </li>
                <li>
                  Your correspondence or dealings with any Third Party Provider are solely between
                  you and that Third Party Provider, and you agree that we will not be liable or
                  responsible for any loss or damage of any sort incurred as the result of such
                  dealings.
                </li>
                <li>
                  Your use of third party web pages linked to the Sites and/or LUMICKO Service may
                  be governed by additional or different terms and conditions. Where this is the
                  case, those additional terms and conditions will apply to your use of such web
                  page or website in addition to these Terms of Service and will prevail over these
                  Terms of Service to the extent of any inconsistency.
                </li>
              </ol>
              <p>
                <strong>7</strong>
                <strong>. </strong>
                <strong>USING THE SITES</strong>
                <strong> </strong>
                <strong>AND THE</strong>
                <strong> </strong>
                <strong>LUMICKO</strong>
                <strong> S</strong>
                <strong>ERVICE</strong>
                <strong> </strong>
                <strong>IS AT YOUR RISK</strong>
              </p>
              <ol type="a">
                <li>
                  You use the Sites and the LUMICKO Service at your risk. You must evaluate, and
                  bear all risks associated with, the use of any Content, including reliance on the
                  accuracy, completeness or usefulness of any Content. All information provided on
                  or via the Sites and the LUMICKO Service is for information purposes only. You
                  should seek your own independent advice with respect to any Content.
                </li>
                <li>
                  We endeavour to provide convenient and functional Sites, but we do not guarantee
                  that the Content will be error free or that the Sites or the servers that operate
                  them are free of viruses or other harmful components.
                </li>
                <li>
                  If your use of the Sites and/or LUMICKO Service results in the need for servicing
                  or replacing property, material, equipment or data, we will not be responsible for
                  such costs.
                </li>
                <li>
                  Without limiting the above provisions, you agree that the Sites and LUMICKO
                  Service is provided “as is” and without express or implied warranty or condition
                  of any kind. To the fullest extent permitted by Applicable Law, we and our content
                  providers (and their affiliates) disclaim any representation or warranty whether
                  express or implied:
                  <ol type="i">
                    <li>
                      as to the title, quality, fitness for a particular purpose, merchantability,
                      accuracy, completeness, or standard of quality and resolution, transmission
                      continuity and timeliness of the Sites, LUMICKO Service, the Software and/or
                      any Content;
                    </li>
                    <li>
                      that the Sites, LUMICKO Service, Software and/or Content will meet your
                      requirements;
                    </li>
                    <li>
                      that your access to and use of the LUMICKO Service, Sites and/or Content will
                      be uninterrupted, free of delay or error, free of viruses, malicious code or
                      other harmful components or otherwise secure;
                    </li>
                    <li>
                      any obligation to maintain the confidentiality of information (although our
                      current practice is to maintain such confidentiality);
                    </li>
                    <li>
                      the results to be obtained from use of any part of the Sites, LUMICKO Service,
                      Software and/or any Content unless otherwise specifically mentioned in these
                      Terms of Service; and
                    </li>
                    <li>
                      that installation or presence of, any Site or Software in your devices, or the
                      LUMICKO Service and/or Content, will not affect the availability or usability
                      of other software, applications, content and/or services.
                    </li>
                  </ol>
                </li>
                <li>
                  If the jurisdiction of Malaysia does not allow the exclusion of implied warranties
                  in accordance with paragraph (d) but allows limitations of a certain maximum
                  extent then we limit our warranties to that extent.
                </li>
                <li>
                  We do not exercise any editorial control over certain Content and do not make any
                  claims as to the truth in such Content.
                </li>
                <li>
                  You acknowledge that certain programs and other Content on the Sites and LUMICKO
                  Service are provided by third party providers, not by us and therefore the
                  availability of Content and programs are outside our control.
                </li>
                <li>
                  We make no representation, promise, warranty, undertaking or guarantee as to the
                  quality, resolution, completeness, accuracy, usefulness, continuity, smoothness or
                  timeliness of any particular Content.
                </li>
                <li>
                  You acknowledge that the Content solely expresses the view of the speaker of the
                  Content, and not our views or any entity associated with us.
                </li>
                <li>
                  We disclaim liability for all Content available on the Sites and LUMICKO Service.
                </li>
                <li>
                  There may be some Content which is not suitable for viewing by minors. You are
                  responsible for checking the identity and/or age of any person who wishes or
                  intends to view any such Content before you permit that person to view such
                  Content and for generally ensuring that minors do not access such Content using
                  your login details and password.
                </li>
                <li>
                  To the fullest extent permitted by Applicable Law, we expressly disclaim any
                  liability for:
                  <ol type="i">
                    <li>
                      any damage to or loss of data suffered by you arising from your use of the
                      Sites, LUMICKO Service, Software and/or any Content;
                    </li>
                    <li>
                      any claim based on contract, tort, or otherwise or any loss of revenue
                      (whether direct or indirect), loss of profits or any consequential loss
                      whether of an economic nature or not;
                    </li>
                    <li>
                      any claim relating to any part of the Sites, LUMICKO Service and/or any
                      Content supplied, provided, sold or made available by or through the Sites
                      and/or LUMICKO Service (or any failure or delay to so supply, provide, sell or
                      make available);
                    </li>
                    <li>
                      any disruption, suspension, delay or failure of the Sites and/or LUMICKO
                      Service or any part thereof which is attributable to an event or circumstance
                      beyond our reasonable control; and
                    </li>
                    <li>
                      any infringement of intellectual property rights arising from your use of the
                      Sites, LUMICKO Service, Software and/or any Content.
                    </li>
                  </ol>
                </li>
              </ol>

              <br />
              <p>
                <strong> 8. LIMITATION OF LIABILITY AND INDEMNITY</strong>
              </p>

              <ol type="a">
                <li>
                  To the fullest extent permitted by Applicable Law, we will under no circumstances:
                  <ol type="i">
                    <li>
                      accept any liability whatsoever for any direct, incidental, consequential or
                      indirect damages, loss or corruption of data, loss of profits, goodwill,
                      bargain or opportunity or loss of anticipated savings or any other loss
                      resulting from your access to, reliance on, or use of, or inability to use the
                      Sites, LUMICKO Service and Content, whether based on warranty, contract, tort,
                      negligence or any other legal theory, and whether or not we know of the
                      possibility of such damage; and
                    </li>
                    <li>
                      pay any amount in compensation (even if we have been negligent) for any
                      liabilities under these Terms of Service, LUMICKO Service, Content, Software
                      and any other goods supplied and/or provided by us.
                    </li>
                  </ol>
                </li>
                <li>
                  To the extent permitted by Applicable Law, you agree to indemnify us, our
                  affiliates, directors, officers, employees, content providers, sub-contractors,
                  licensors and/or agents against any actions, liability, costs, claims, losses,
                  damages, proceedings and/or expense arising from, in connection with or which is
                  related to:
                  <ol type="i">
                    <li>
                      {` your use or others' use of the Sites, Software, LUMICKO Service and/or the Content
                  through your devices and/or registered account;`}
                    </li>
                    <li>
                      your violation of any third party right, including without limitation any
                      copyright, trademark, trade secret or other property, or privacy right; and
                    </li>
                    <li>any breach or non-observance of any of these Terms of Service by you.</li>
                  </ol>
                </li>
              </ol>

              <br />
              <p>
                <strong>9</strong>
                <strong>. </strong>
                <strong>SURVIVAL</strong> <br />
                {`The provisions of these Terms of Service entitled "The Use
                of the Sites and LUMICKO Service Is At Your Risk ", " Limitation of Liability and
                Indemnity" and "General Provisions" will survive cancellation or termination of your
                LUMICKO account or termination of your subscription for any LUMICKO Service.`}
              </p>
              <p>
                <strong>1</strong>
                <strong>0</strong>
                <strong>. </strong>
                <strong>NOTICES</strong>
              </p>
              <ol type="a">
                <li>
                  Subject to the Applicable Law, we will give you any necessary notices by posting
                  them on the Sites. You agree:
                  <ol type="i">
                    <li>to check the Sites for notices; and</li>
                    <li>
                      that you will be considered to have received a notice when it is posted on the
                      Sites.
                    </li>
                  </ol>
                </li>
              </ol>

              <p>
                <strong>11. GENERAL PROVISIONS</strong>
              </p>
              <ol type="a">
                <li>
                  If any provisions of these Terms of Service shall be construed to be illegal,
                  invalid or unenforceable for any reason, such provisions shall not affect the
                  legality, validity or enforceability of the other provisions of these Terms of
                  Service. The illegal, invalid or unenforceable provision shall be amended to the
                  extent necessary to make them legal, valid or enforceable or, if not possible to
                  do so, deleted from these Terms of Service, but all other provisions of these
                  Terms of Service shall continue in full force and effect.
                </li>
                <li>
                  The governing law of and forum for dispute resolution relating to these Terms of
                  Service shall be Malaysia. All disputes arising in connection with these Terms of
                  Service, shall be submitted to the jurisdiction of the courts in Malaysia.
                </li>
                <li>
                  Our failure to enforce any rights or provisions under these Terms of Service shall
                  not constitute a waiver of such or any other provision.
                </li>
                <li>
                  We shall not be liable or responsible for any failure to fulfil any of our
                  obligations due to causes beyond our reasonable control.
                </li>
                <li>
                  Should there be any inconsistencies between the English version and any other
                  language versions (if any) of these Terms of Service, the English version shall
                  prevail.
                </li>
                <li>
                  Subject to Applicable Law, we can transfer our rights and obligations hereunder to
                  any person or entity without your consent. We can also use an agent or
                  subcontractor to perform our responsibilities.
                </li>
                <li>
                  A person or entity who is not a party to these Terms of Service shall have no
                  right to enforce any part of these Terms of Service.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfServicePage
